import { Component, EventEmitter, Output, TemplateRef, ViewChild } from "@angular/core";
import { NgbModal, NgbModalOptions, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { BookingService } from "../../services/booking.service";
import { Helper } from "src/app/core/helpers/helper";

@Component({
  selector: "app-promo-code-modal",
  templateUrl: "./promo-code-modal.component.html",
  styleUrl: "./promo-code-modal.component.scss",
  standalone: false
})
export class PromoCodeModalComponent {
  promoModalRef!: NgbModalRef;
  config: NgbModalOptions = { size: "md", centered: true, backdrop: "static" };

  bookingData: any = {};
  promoCodeList: Array<any> = [];

  @Output() promoApplied = new EventEmitter();

  @ViewChild("template", { static: true }) template!: TemplateRef<any>;

  constructor(public helper: Helper, private modalService: NgbModal, private bookingService: BookingService) {}

  /**
   * Opens the promo code modal with the provided booking data.
   * Fetches the list of promo codes available for the booking.
   *
   * @param bookingData The data related to the current booking.
   */
  openModal(bookingData: any): void {
    this.bookingData = bookingData;

    this.promoModalRef = this.modalService.open(this.template, this.config);
    this.promoModalRef.result.then(
      () => this.closeModal(),
      () => this.closeModal()
    );

    this.getPromoCodeList();
  }

  /**
   * Handles the error event for promo code images.
   * Sets the image source to a default image if an error occurs.
   *
   * @param event The event object containing the error details.
   */
  handleImageError(event: any): void {
    event.target.src = this.helper.DefaultImages.DefaultPromoCode;
  }

  /**
   * Fetches the list of promo codes available for the current booking.
   * Updates the promoCodeList property with the fetched promo codes.
   */
  getPromoCodeList(): void {
    const parameters: any = {
      cityId: this.bookingData.cityId,
      countryId: this.bookingData.countryId,
      vehicleTypeId: this.bookingData.vehicleTypeId,
      isShowSuccessToast: false,
      isShowErrorToast: false,
      priceMode: this.bookingData.priceMode
    };
    if (this.bookingData.merchantId) {
      (parameters["businessType"] = this.bookingData.businessType),
        (parameters["merchantId"] = this.bookingData.merchantId),
        (parameters["bookingTime"] = this.bookingData.bookingTime || Date.now()),
        (parameters["paymentMethod"] = this.bookingData.paymentMethod),
        (parameters["latitude"] = this.bookingData.latitude),
        (parameters["longitude"] = this.bookingData.longitude);
    } else if (this.bookingData.mainCategoryId) {
      (parameters["mainCategoryId"] = this.bookingData.mainCategoryId),
        (parameters["businessType"] = this.bookingData.businessType);
    }
    this.bookingService.getPromoCodeList(parameters).subscribe((response: any) => {
      this.promoCodeList = [];
      if (response) {
        this.promoCodeList = response.promoCodes;
      }
    });
  }

  /**
   * Applies the selected promo code to the current booking.
   * Validates the promo code and emits an event if the promo code is valid.
   *
   * @param promo The promo code object to be applied.
   */
  applyPromo(promo: any): void {
    const currentTime = Date.now();
    const parameters: any = {
      promoCode: promo.code,
      cityId: this.bookingData.cityId,
      bookingTime: this.bookingData.bookingTime || currentTime,
      paymentMethod: this.bookingData.paymentMethod,
      vehicleTypeId: this.bookingData.vehicleTypeId,
      priceMode: this.bookingData.priceMode,
      latitude: this.bookingData.latitude,
      longitude: this.bookingData.longitude
    };
    if (this.bookingData.merchantId) {
      parameters["businessType"] = this.bookingData.businessType;
      parameters["products"] = this.bookingData.products;
      parameters["merchantId"] = this.bookingData.merchantId;
    } 
    if(this.bookingData.mainCategoryId) {
      parameters["mainCategoryId"] = this.bookingData.mainCategoryId;
      parameters["businessType"] = this.bookingData.businessType;
    }
    this.bookingService.validatePromoCode(parameters).subscribe((response: any) => {
      if (response) {
        this.promoApplied.emit(promo);
        this.closeModal();
      }
    });
  }

  /**
   * Closes the promo code modal and clears the promo code list.
   */
  closeModal(): void {
    this.promoModalRef.close();
    this.promoCodeList = [];
  }
}
